import { useMemo } from "react";

import { useFetchProjectEventListQuery } from "@domains/project/network/projectQueries";
import EventInfoViewModel from "@domains/project/viewModel/ProjectEventInfoViewModel";

import SectionLayout from "../../layouts/SectionLayout/SectionLayout";
import ProjectEventCard from "../../components/ProjectEventCard/ProjectEventCard";

import * as S from "./ProjectEventSection.style";

interface ProjectEventSectionProps {
  projectId: string;
}

const ProjectEventSection = ({ projectId }: ProjectEventSectionProps) => {
  const { data: projectEventListMap, status } =
    useFetchProjectEventListQuery(projectId);

  const projectEventListByDate = useMemo(() => {
    return Array.from(projectEventListMap?.entries() || []);
  }, [projectEventListMap]);

  return (
    <S.SectionListWrapper>
      {projectEventListByDate.map(
        ([title, list]: [string, EventInfoViewModel[]]) => (
          <SectionLayout key={title} title={title} status={status}>
            <S.ListWrapper>
              {list.map((event) => (
                <ProjectEventCard
                  key={event.id}
                  projectId={projectId}
                  eventId={event.id}
                  eventInfo={event}
                  host={event.host}
                  participantList={event.participantList}
                />
              ))}
            </S.ListWrapper>
          </SectionLayout>
        ),
      )}
    </S.SectionListWrapper>
  );
};

export default ProjectEventSection;
